const TWO_HOURS = 2 * 60 * 60 * 1000

const parseDateTime = value => {
  const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec(value ?? '')
  if (!match) return null

  const [, year, month, day, hour, minute] = match.map(Number)
  const date = new Date(year, month - 1, day, hour, minute)

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day ||
    date.getHours() !== hour ||
    date.getMinutes() !== minute
  ) {
    return null
  }

  return date
}

const sourceInput = wrapper => wrapper?.querySelector?.('[x-ref="input"]') ?? null

export default () => ({
  startChanged(event) {
    const row = event.target?.closest?.('[data-poll-date-option]')
    if (!row) return

    const start = sourceInput(row.querySelector('[data-poll-date-start]'))?.value ?? ''
    const previousStart = row.dataset.previousStart ?? ''
    row.dataset.previousStart = start

    if (row.dataset.allDay === 'true') return

    const endInput = sourceInput(row.querySelector('[data-poll-date-end]'))
    if (!endInput) return

    const newStartDate = parseDateTime(start)
    if (!newStartDate) return

    const endDate = parseDateTime(endInput.value)
    const previousStartDate = parseDateTime(previousStart)

    if (endInput.value === '') {
      this.setEnd(endInput, new Date(newStartDate.getTime() + this.previousDuration(row)))
      return
    }

    if (!endDate || !previousStartDate) return

    const difference = newStartDate.getTime() - previousStartDate.getTime()
    if (difference === 0) return

    this.setEnd(endInput, new Date(endDate.getTime() + difference))
  },

  previousDuration(row) {
    const rows = [...this.$root.querySelectorAll('[data-poll-date-option]')]
    const rowIndex = rows.indexOf(row)

    for (let index = rowIndex - 1; index >= 0; index -= 1) {
      const candidate = rows[index]
      if (candidate.dataset.allDay === 'true') continue

      const start = parseDateTime(sourceInput(candidate.querySelector('[data-poll-date-start]'))?.value)
      const end = parseDateTime(sourceInput(candidate.querySelector('[data-poll-date-end]'))?.value)
      const duration = start && end ? end.getTime() - start.getTime() : 0

      if (duration > 0) return duration
    }

    return TWO_HOURS
  },

  setEnd(input, date) {
    input._flatpickr?.setDate(date, true)
  }
})
